// extracted by mini-css-extract-plugin
export default {"mainSection":"debug-section_mainSection__BBd6f","disclaimer":"debug-section_disclaimer__KXsgG"};